module.exports = __webpack_public_path__ + "media/images/stickers/sticker2-55221aeefad054935fd8cf2fb3d76503.svg";